<div class="chatroom-form-container">
    <form class="converse-form chatroom-form">
        <fieldset class="form-group">
            <span class="spinner fa fa-spinner centered"/>
        </fieldset>
    </form>
</div>
